import { render, staticRenderFns } from "./UserSelected.vue?vue&type=template&id=c10d5552"
import script from "./UserSelected.vue?vue&type=script&lang=js"
export * from "./UserSelected.vue?vue&type=script&lang=js"
import style0 from "./UserSelected.vue?vue&type=style&index=0&id=c10d5552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports